import React from 'react'
import { formatDate } from '@/utils/dateUtilities'

function DateTimeRenderer ({ value }) {
  return <React.Fragment>{ formatDate(value) }</React.Fragment>
}

export { DateTimeRenderer }



// WEBPACK FOOTER //
// ./src/components/report-tables/renderers/dateTimeRenderer.js